<form [formGroup]="DinamicForm">
    <dnc-title [check]="check" [editable]="editable"></dnc-title>
    <input type="text" class="form-control inputNumber {{(check?.target?.uppercase)?'tx-uppercase':''}}  {{(check?.target?.lowercase)?'tx-lowercase':''}}" [placeholder]="check?.target?.placeholder" 
    
    [readonly]="check?.target?.readonly || !editable"  
    [ngClass]="(check?.target?.readonly || !editable) ? 'disabled' : ''"     
    (change)="dynamicEmit()" [formControlName]="this.check.formControlName"  [maxlength]="check.target.validators?.maxLength || check?.target?.maxLength">
    <small class="text-danger" *ngIf="editable && fieldisValid.campoEsValido(this.check?.formControlName, DinamicForm)">{{check.validateMessage}}</small>    
</form>
